module.exports = __webpack_public_path__ + "static/media/test12.4b0051f8.jpeg";